<template>

  <div v-if="votes">

    <span v-if="!entries.length">
      <div v-if="$store.getters.user" class="hit-panel hit-panel-default">
        <div class="hit-panel-body" v-html='$tc("message.feedback", 2)+": "+$tc("message.noEntry", 2)' v-bind:style="{'background-color': survey.colors.accent_color, 'border-color': survey.colors.accent_color, 'color': survey.colors.accent_color2}" />
      </div>
    </span>

    <transition name="fade" v-else>
      <div :key="key+'1'">


          <vote_details
          v-if="details"
          :surveyName="survey.name"
          :colors="survey.colors"
          :details="details"
          :onClose="function(){ details = false; }"
          :settings="{hideCloseBtn: true, hideHeader: false}"
          style="margin-bottom:-20px"
           />

           <div class="hit-panel hit-panel-default" v-bind:style="{'border-color': survey.colors.background_color}">

          <div class="hit-panel-footer" v-bind:style="{'background-color': survey.colors.background_color, 'border-color': survey.colors.background_color, 'color': survey.colors.text_color}">
            <div class="hit-pull-left">{{key}}/{{entries.length}}</div>
            <div class="hit-text-right">
              <a v-bind:style="{'color': survey.colors.text_color}" href="#" @click.prevent="set_key(-1)" class="hit-html-a">
                <i class="hit-glyphicon hit-glyphicon-arrow-left"></i> {{$t("message.back")}}
              </a> |
              <a v-bind:style="{'color': survey.colors.text_color}" href="#" @click.prevent="set_key(1)" class="hit-html-a">{{$t("message.next")}}
                <i class="hit-glyphicon hit-glyphicon-arrow-right"></i>
              </a>
            </div>
            <div class="hit-clearfix"></div>
          </div>

        </div>





    </div>
    </transition>


  </div>

</template>

<script>



import vote_details from '@core/components/votes/parts/details'
import md5 from 'js-md5'

export default{

  components: {vote_details},
  props: {survey: Object, design: String, votes: Array, entries: Array},

  data: function () {

    return {
      titles: [this.$t('message.username'), this.$tc('message.feedback', 1), this.$t('message.date')],
      key: 1,
      details: false
    }
  },

  methods: {

    set_key: function(add){

      this.key = this.key + add;

      if(this.key > this.entries.length)
        this.key = 1;

      if(this.key < 1)
        this.key = this.entries.length;

      this.set_details();
    },

    set_details: function(){

      var row = this.key;


      this.$hit_post({url: 'hitclick/votes/get_vote',
        data: {user: this.survey.user, board: md5(this.survey.ID+''), ID: md5(this.entries[row].ID+'')},
        callback: function (ret) {


          if (ret.data[0]) {

            if(ret.data[0]){
              this.details = ret.data[1]
              this.details.hint = "";
            }

          }
        }.bind(this)})



    },

  },

  mounted(){

    this.key = 1;

    this.set_details();


  }



}

</script>
